export class SistemaResponseModel {
    idSistema : number;
    codigoSistema : string;
    nombreSistema : string;
    str_ESPB: string;
    str_ESPB_Mantenimiento: string;

    constructor() {
      this.idSistema = 0;
      this.codigoSistema = "";
      this.nombreSistema = ""; 
      this.str_ESPB = "";
      this.str_ESPB_Mantenimiento = "";
    }
  }
  